module.exports = __webpack_public_path__ + "static/media/preriousTest.3c4799ac.png";